import { render, staticRenderFns } from "./AdvantageCard.vue?vue&type=template&id=5372a80f&scoped=true&"
import script from "./AdvantageCard.vue?vue&type=script&lang=js&"
export * from "./AdvantageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372a80f",
  null
  
)

export default component.exports